























































import Vue from 'vue'
import dayjs from 'dayjs'
import mixin from './cardmixin.vue'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const csp = new CustomerServiceProxy()
const dictService = new DictServiceProxy();

export default Vue.extend({
  name: 'screening-customers-table',
  mixins: [mixin],
  data() {
    return {
      data: [],
      badgeStatus: [],
      loading: false,
      timeList: [],
      createTimeType: '3',
    }
  },
  async created() {
    let res = await dictService.dictionary('customer-create-time');
    this.timeList = res.data;
  },
  computed: {
    columns() {
      return [
      {
        title: this.$t('page_material_customer_name'),
        key: 'name',
        dataIndex: 'name',
        ellipsis: true,
        width: 260,
        scopedSlots: { customRender: 'name' },
      },
      {
        title: this.$t('page_ops_machine_search_create_time'),
        key: 'createTime',
        dataIndex: 'createTime',
        ellipsis: true,
        customRender: (t) => {
          return dayjs(t).format('YYYY-MM-DD HH:mm:ss') || ''
        }
      },
      {
        title: this.$t('page_plan_create_user'),
        key: 'createUser',
        dataIndex: 'createUser',
        ellipsis: true,
        width: 100
      }
    ]
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    navTo(keyWord) {
      this.ViewMOre('screening-customers-table', {keyWord});
    },
    getList() {
      this.loading = true
      const dto: any = {
        query:{current: 1,size: -1},
        createTimeType: this.createTimeType
      }
      csp.getCustomerByCreateTime(dto)
        .then((res) => {
          this.data = res.records
          console.log(this.data);
          
          this.checkScrollY('screening-customers', this.data.length)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    /* changeInput(name) {
      this.getList(name)
    } */
    onlineStateChange(e){
      this.createTimeType = e;
      this.getList()
    }
  }
})
